import { useEffect, useState } from 'react';
import Emoji from 'common/components/Emoji';
import Stars from 'common/components/Stars';
import server from 'common/utils/server';
import { loadIntercom } from 'common/utils/intercom';
import star from '../../../assets/images/star-notification.png';
import { dateMonthYearFormat, DateTime } from 'common/utils/date';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import AlchemyNotifications from './AlchemyNotifications';
import { encouragementText, feedbackText } from './helpers';

export default function PositiveNotification() {
  const [notification, setNotification] = useState({});
  const [open, setOpen] = useState(false);
  const shouldPulse = !notification.dismissed_at;

  const hasNotification = !isEmpty(notification);
  const isFeedback = notification.type === 'feedback';

  const { currentPerson, featureFlags, environment } = window.initializationData || {};
  loadIntercom(
    currentPerson,
    environment,
    featureFlags.role_based_access_control,
    featureFlags.intercom_consolidated
  );

  const achievementsEnabled = featureFlags.achievements_p0;

  const onClick = () => {
    setOpen(!open);
    if (!notification.dismissed_at) {
      const dismissedAt = new Date();
      setNotification({ ...notification, dismissed_at: dismissedAt });
      server.put(`/api/v1/notifications/${notification.id}`, {
        dismissed_at: dismissedAt,
      });
    } else {
      // Track click event with ahoy
      server.put(`/api/v1/notifications/${notification.id}`, {});
    }
  };

  useEffect(() => {
    const manageTeamElem = document.getElementsByClassName('manage-team-new')[0];
    if (manageTeamElem) {
      manageTeamElem.addEventListener('click', function currentManageTeamPage() {
        window.location.pathname = '/admin/company/manage_team';
      });
    }

    const fetchNotification = async () => {
      const response = await server.get('/api/v1/notifications');
      setNotification(get(response, 'notifications.positive_notification', {}));
    };
    fetchNotification();
    const interval = setInterval(
      () => {
        fetchNotification();
      },
      1000 * 60 * 60
    );

    return () => clearInterval(interval);
  }, []);

  if (achievementsEnabled) {
    return <AlchemyNotifications notification={hasNotification ? notification : undefined} />;
  }

  if (!hasNotification) return null;

  return (
    <>
      <button onClick={onClick} className={`star-notification-wrapper ${open ? 'active' : ''}`}>
        <img src={star} className={`${shouldPulse ? 'star-pulse' : 'notransition'}`} alt="" />
      </button>
      {open && (
        <div className="pn-content">
          <div className="pn-header">
            {isFeedback ? feedbackText : encouragementText}
            <Emoji emoji={{ id: 'smiley' }} size={14} />
          </div>
          <div className="pn-divider" />
          {isFeedback ? (
            <>
              <div className="pn-top-row">
                <div className="pn-date">
                  {DateTime.fromISO(notification.metadata.responded_at).toFormat(
                    dateMonthYearFormat
                  )}
                </div>
                <Stars id="pn-stars" stars={5} />
              </div>
              <div className="pn-text">{notification.text}</div>
              <a
                className="pn-link"
                target="_blank"
                rel="noopener noreferrer"
                href={`/requests/${notification.metadata.uuid}`}
              >
                See feedback <i className="fa fa-arrow-right" />
              </a>
            </>
          ) : (
            <>
              <div className="pn-text">{notification.text}</div>
              <div className="pn-sub-text">— A Fellow Member of the CX Community</div>
            </>
          )}
        </div>
      )}
    </>
  );
}
